import * as React from 'react';
import { useSelector } from 'react-redux';

import { ControlsContainer as Controls } from './Controls';
import { Features, IFeaturesApi } from './Features';
import { InfrastructureFeatures, IInfrastructureFeaturesApi } from './Infrastructure';
import { NewbuildingPromoPins } from './NewbuildingPromoPins';
import { NewbuildingsPolygonsContainer } from './NewbuildingsPolygons';
import { PolygonsContainer } from './Polygons';
import { selectIsInfrastructureOnMapEnabled } from '../../../selectors/infrastructure';
import { useApplicationContext } from '../../ApplicationContext';
import { ExpPinsAndPopupRedesign } from 'shared/map-search/experiments/declarations';
import { useDeviceType } from '@cian/ui-kit';

export function MapLayers() {
  const { config } = useApplicationContext();
  const isMobile = useDeviceType() !== 'desktop';

  const featuresRef = React.useRef<IFeaturesApi>(null);
  const infrastructureFeaturesRef = React.useRef<IInfrastructureFeaturesApi>(null);
  const isInfrastructureEnabled = useSelector(selectIsInfrastructureOnMapEnabled);
  const isRedesign =
    (ExpPinsAndPopupRedesign.use() === 'B' &&
      config.get<boolean>('BX.PinsAndPopupRedesign.2026.Enabled') &&
      isMobile) ||
    (!isMobile && config.get<boolean>('BX.PinsAndPopupRedesign.2026.Desktop.Enabled')) ||
    false;

  React.useEffect(() => {
    const featuresApi = featuresRef.current;
    const infrastructureFeaturesApi = infrastructureFeaturesRef.current;

    infrastructureFeaturesApi?.init();
    featuresApi?.init();

    return () => {
      infrastructureFeaturesApi?.destroy();
      featuresApi?.destroy();
    };
  }, []);

  return (
    <>
      <Features isRedesign={isRedesign} ref={featuresRef} />
      {isInfrastructureEnabled && <InfrastructureFeatures ref={infrastructureFeaturesRef} />}
      <Controls />
      <PolygonsContainer />
      <NewbuildingsPolygonsContainer />
      <NewbuildingPromoPins isRedesign={isRedesign} />
    </>
  );
}
